import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(({ breakpoints: BP }) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    margin: '50px 10%',
    borderRadius: 10,
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#fff',
    color: '#283142',
    boxSizing: 'border-box',
    padding: 40,
    minHeight: 500,

    backgroundImage: "url('/images/home/bg.jpg')",
    backgroundAttachment: 'fixed',

    [BP.between('xs', 'md')]: {
      padding: '7% 5% 60px',
      margin: '35px 5%',
      backgroundSize: 'contain',
    },
  },

  slider: {
    height: '100%',
    '& ul': {
      bottom: -55,
    },
    '& li': {
      width: 15,
      height: 15,
      backgroundColor: '#218683',
      borderRadius: 15,
      marginLeft: 10,
      transition: 'all 0.2s ease-in-out',
    },
    '& button:before': {
      display: 'none',
    },
    '& li.slick-active': {
      backgroundColor: '#ffdf80 !important',
    },
    [BP.between('xs', 'md')]: {
      '& ul': {
        bottom: -40,
      },
    },
  },
}));
